import { InputGroup, FormControl } from 'react-bootstrap';
import i18n from "i18next";
import { ReactComponent as SearchIcon } from '../../../../../assets/search-icon.svg';

export default function SearchField (props) {
    const { term, onSearch, placeholder = i18n.t('components.searchBar.placeholderSearch'), children } = props;

    return (
        <InputGroup className="search-field">
            <InputGroup.Text>
                <SearchIcon style={{ width: '16px', height: '16px' }} />
            </InputGroup.Text>
            <FormControl
                value={term}
                onChange={onSearch}
                placeholder={placeholder}
                aria-label={placeholder}
                style={{ borderLeft: 'none' }}
            />
        </InputGroup>
    );
};
